import styled, { css } from "styled-components";
import { type ColorProps, type MaxWidthProps, color, maxWidth } from "styled-system";
import * as Input from "../../../../../../../common-deprecated/styles/toyota/Input";
import * as Button from "../../../../../../../common-deprecated/styles/toyota/Button";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

const COLOR_DARK_RED = "#BF0000"; /* Specific color */

export const Visual = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 100%;
    max-width: 138px;
    height: 100%;
    max-height: 128px;
    margin: 34px auto;
    color: ${({ theme }) => theme.color.grey4};

    svg {
        max-width: 100%;
        height: auto;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 54px;

    button {
        font-size: 1.3rem;
        line-height: 1.8em;
    }

    button + button {
        margin-top: 12px;
    }

    ${Button.OutlinePrimary} {
        color: ${({ theme }) => theme.color.dark};
    }

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;

        button + button {
            margin-top: 0;
            margin-left: 12px;
        }
    }
`;

export const SummaryTitle = styled.h3`
    font-size: 2.2rem;
    line-height: 2.8rem;
    ${({ theme }) => css`
        font-family: ${theme.fontFamily.bold};
        color: ${theme.color.dark};
    `};
`;

export const ExtrasTitle = styled.h4`
    margin-bottom: 6px;
    font-size: 1.7rem;
    line-height: 1.7rem;
    ${({ theme }) => css`
        font-family: ${theme.fontFamily.bold};
        color: ${theme.color.dark};
    `};
`;

export const InfoText = styled.div`
    margin-bottom: 24px;
    font-size: 1.3rem;
    line-height: 2rem;
    ${({ theme }) => css`
        font-family: ${theme.fontFamily.regular};
        color: ${theme.color.dark};
    `};
`;

export const Legend = styled.ul`
    display: block;
    margin: 0 0 40px;
    padding: 0;
`;

export const LegendItem = styled.li`
    display: inline-block;
    font-size: 1.3rem;
    line-height: 1.7rem;
    &::before {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin-right: 8px;
        content: "";
        border-radius: 50%;
    }
    & + li {
        margin-left: 16px;
    }
    ${({ theme }) => css`
        font-family: ${theme.fontFamily.regular};
        color: ${theme.color.dark};
        &::before {
            background-color: ${theme.color.dark};
        }
    `};
`;

export const ExtraLegendItem = styled(LegendItem)`
    ${({ theme }) => css`
        &::before {
            background-color: ${theme.color.grey3};
        }
    `};
`;

export const ExceedLegendItem = styled(LegendItem)`
    color: ${COLOR_DARK_RED};
    &::before {
        background-color: ${COLOR_DARK_RED};
    }
`;

export const ExtraListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 40px 0;

    ${Input.Checkbox} {
        color: ${({ theme }) => theme.color.dark};
    }

    @media ${getBreakpoint("up", "md")} {
        max-height: 150px;
    }
`;

export const IconWrapper = styled.span`
    color: ${({ theme }) => theme.color.primary};
    svg {
        position: relative;
        top: 3px;
        margin-right: 6px;
    }
`;

export const StatisticBar = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 15px;
    margin: 12px 0 16px;
    border-radius: 4px;
    overflow: hidden;
`;

export const StatItem = styled.div<ColorProps & MaxWidthProps>`
    width: 100%;
    &:not(:first-child) {
        border-left: 1px solid ${({ theme }) => theme.color.lightest};
    }
    ${maxWidth};
    ${color};
`;
